var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _g, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollabiz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 362,
    height: 396,
    viewBox: "0 0 362 396",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.037 13.6846L257.197 115.502L257.197 158.186L119.364 56.7319L30.6447 126.812L38.6707 133.378L38.6707 174.968L1.00658 147.377L0.666446 102.506L119.037 13.6846Z",
    fill: "#3BB2C4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_182_101",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 216,
    y: 200,
    width: 39,
    height: 112
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 216.27,
    y: 200.867,
    width: 2.91855,
    height: 110.905,
    fill: "#3F51B5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 221.375,
    y: 200.867,
    width: 2.91855,
    height: 110.905,
    fill: "#3F51B5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 226.484,
    y: 200.867,
    width: 2.91855,
    height: 110.905,
    fill: "#3F51B5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 231.594,
    y: 200.867,
    width: 2.91855,
    height: 110.905,
    fill: "#3F51B5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 236.699,
    y: 200.867,
    width: 2.91855,
    height: 110.905,
    fill: "#3F51B5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 241.805,
    y: 200.867,
    width: 2.91855,
    height: 110.905,
    fill: "#3F51B5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 246.914,
    y: 200.867,
    width: 2.91855,
    height: 110.905,
    fill: "#3F51B5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 252.023,
    y: 200.867,
    width: 2.91855,
    height: 110.905,
    fill: "#3F51B5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_182_101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.47 307.03L215.4 285.141L215.4 266.315L255.47 217.065L255.47 307.03Z",
    fill: "#027CC1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6421 121.34L84.6359 89.9653L86.0982 281.719L216.132 347.132L216.132 339.501L256.562 361.755L256.562 370.175L216.491 394.557L45.6421 307.928L45.6421 121.34Z",
    fill: "#3BB2C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.43 75.0072L159.791 95.437L139.423 111.698L156.522 126.88L157.757 168.086L113.193 136.573L111.849 91.7203L132.43 75.0072Z",
    fill: "#81C525"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M360.439 103.828L219.73 4.68712L169.577 44.0083L197.73 64.7928L220.849 47.7545L360.439 146.147L360.439 103.828Z",
    fill: "#3BB2C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M166.029 100.18L202.109 126.812L203.324 281.743L323.288 347.232L323.138 327.532L360.105 306.457L360.589 370.298L323.647 394.657L166.028 307.928L166.029 100.18Z",
    fill: "#3BB2C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollabiz);
export default __webpack_public_path__ + "static/media/collabiz.032d26916a973815d564480cf133ee84.svg";
export { ForwardRef as ReactComponent };